<template>
  <div class="tree-box">
    <el-tree :data="treeData"  default-expand-all  :expand-on-click-node="false" ref="vueTree"  :props="defaultProps" >
       <span class="custom-tree-node " slot-scope="{ node, data }" >
         <span @click="getResourceList(data)" class="tree-span" :class="{ active: data.id === functionId }" >{{ node.label }}</span>
         <span style="margin-left: 10px;">
          <el-button
            type="text"
            size="mini"
            class="add"
            @click.native="add(data.id)" title="新增子功能" v-if="data.id === functionId && data.type === 1 ">
             <svg
               t="1545994194917"
               class="icon"
               style="vertical-align:middle;"
               viewBox="0 0 1024 1024"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1272"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               width="15"
               height="15"
             >
              <path
                d="M511.17819 1023.449171C232.458621 1030.059121-1.643784 782.185986 0.008703 508.974708 1.661191 236.865089 239.068571-1.64395 516.135653 0.008538c271.55879 1.652488 510.618658 239.059868 508.966171 516.12695C1023.449336 787.694278 787.694443 1031.711609 511.17819 1023.449171zM491.34834 97.505304c-195.544362-1.652488-418.630184 188.383583-394.944528 457.188227 15.974046 181.222803 190.03607 398.249504 459.942373 374.013019 181.773632-16.524876 396.046187-190.586899 371.809703-459.391544C911.080182 278.177278 730.408208 79.327941 491.34834 97.505304z" p-id="2193"></path><path d="M560.201988 362.454144c0 27.541459 0.550829 55.082919 0 82.624378-0.550829 15.423217 5.508292 20.38068 20.38068 19.829851 55.082919-0.550829 110.165838 0 165.248757-0.550829 15.974046 0 22.583997 4.406634 21.482338 20.931509-1.101658 18.728192-1.101658 37.456385 0 55.633748 0.550829 14.872388-5.508292 19.279022-19.279022 18.728192-55.082919-0.550829-110.165838 0-165.248757-0.550829-16.524876 0-23.134826 4.957463-22.583997 22.033168 1.101658 54.53209 0 108.51335 0.550829 163.04544 0.550829 17.626534-6.059121 23.134826-22.583997 22.033168-17.075705-1.101658-34.702239-1.101658-51.777944 0-15.974046 1.101658-21.482338-4.957463-21.482338-21.482338 0.550829-53.430431-0.550829-107.411692 0.550829-160.842123 0.550829-20.38068-6.60995-25.888972-25.888972-25.338143-53.430431 1.101658-107.411692 0-160.842123 0.550829-14.872388 0-21.482338-4.406634-20.38068-19.829851 1.101658-18.728192 1.101658-37.456385 0-55.633748-1.101658-15.974046 5.508292-19.829851 20.38068-19.829851 54.53209 0.550829 108.51335-0.550829 163.04544 0.550829 17.626534 0.550829 24.236484-4.406634 23.685655-23.134826-1.101658-54.53209 0-108.51335-0.550829-163.04544 0-16.524876 5.508292-22.033168 21.482338-21.482338 17.626534 1.101658 35.803897 1.101658 53.430431 0 14.872388-0.550829 20.931509 4.406634 20.38068 19.829851C559.651159 306.269567 560.201988 334.361856 560.201988 362.454144z"
                p-id="1273"
              ></path>
            </svg>
          </el-button>
          <el-button
            type="text"
            size="mini"
            class="update"
            @click.native="update(data,1)" v-if="data.id !== '0'&& data.id === functionId && (data.state === null || data.state === 0)" title="启用此功能">
             <svg
               t="1545994194917"
               class="icon"
               style="vertical-align:middle;"
               viewBox="0 0 1024 1024"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1272"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               width="15"
               height="15"
             >
              <path
                d="M508 990.4c-261.6 0-474.4-212-474.4-474.4S246.4 41.6 508 41.6s474.4 212 474.4 474.4S769.6 990.4 508 990.4zM508 136.8c-209.6 0-379.2 169.6-379.2 379.2 0 209.6 169.6 379.2 379.2 379.2s379.2-169.6 379.2-379.2C887.2 306.4 717.6 136.8 508 136.8zM412.8 326.4l284.8 189.6L412.8 705.6 412.8 326.4z" p-id="2193"></path>
             </svg>
          </el-button>
              <el-button
                type="text"
                size="mini"
                class="update"
                @click.native="update(data,0)" v-if="data.id !== '0'&& data.id === functionId && data.state === 1" title="停用此功能">
             <svg
               t="1545994194917"
               class="icon"
               style="vertical-align:middle;"
               viewBox="0 0 1024 1024"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1272"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               width="15"
               height="15"
             >
              <path
                d="M512 32A480 480 0 1 0 992 512 480.64 480.64 0 0 0 512 32z m0 896A416 416 0 1 1 928 512 416.64 416.64 0 0 1 512 928z" p-id="2193"></path>
               <path d="M384 320h64v384H384zM576 320h64v384H576z"  p-id="2668"></path>
             </svg>
          </el-button>
        </span>
       </span>
    </el-tree>
  </div>
</template>
<script>
export default {
  name: 'tree',
  props: {
    treeData: {
      data: Array
    },
    functionId: {
      data: String,
      default: ''
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  methods: {
    getResourceList(data) {
      this.$emit('getResourceList', { functionId: data.id, type: data.type });
      this.$emit('edit', data.id);
    },
    add() {
      this.$emit('add');
    },
    update(data, state) {
      this.$emit('updateFunction', { data, state });
    }
  }
};
</script>
<style lang="scss" >
  .tree-box{
    .el-tree-node.is-current{
      &>.el-tree-node__content>.custom-tree-node{
        /*color: dodgerblue;*/
      }
    }
    .active{
      color: dodgerblue;
    }
    .el-tree-node:focus > .el-tree-node__content ,.el-tree-node:hover> .el-tree-node__content {
      background-color:transparent;
    }
    .tree-span{
      font-size: 14px;
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      min-width: 120px;
    }
    .add{
      font-size: 18px;
      color: #000;
    }
    .update{
      font-size: 18px;
      color: #000;
    }
    .add:hover,.add:focus,.update:hover,.update:focus{
      color: dodgerblue;
      .icon{
        fill: dodgerblue;
      }
    }

  }
</style>
